import { getTranslatedString } from '@skinsoft/ui'
import { get } from 'lodash';
import { translatedTitle } from '../location/selectors';
import { Institution, InstitutionDataStore } from './institution-data-store';

export const id = (institution: Institution) => get(institution, 'id');

export const title = (institution: Institution, locale: string) => getTranslatedString(get(institution, 'translatedTitle'), locale);